'use client'

import React from 'react'

interface Props {
    children: React.ReactNode
}

/**
 * Top-level main navigation landmark.
 *
 * Renders a `<nav>` element containing a horizontal `<ul>` list. Each list item is expected
 * to be a `MainNavigationListItem` so that keyboard and pointer interaction are handled
 * consistently across the navigation bar.
 */
export const MainNavigationList = ({ children }: Props) => {
    return (
        <nav className="main-navigation">
            <ul className="inline-flex shrink-0 list-none m-0 p-0 h-full">{children}</ul>
        </nav>
    )
}
